export const transactionTypes = {
  LOADING: "LOADING",
  FETCH_TRANSACTIONS: "FETCH_TRANSACTIONS",
  FETCH_TRANSACTIONS_TALLY: "FETCH_TRANSACTIONS_TALLY",
  FETCH_TRANSACTIONS_STAFF: "FETCH_TRANSACTIONS_STAFF",
};
